import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import PublicLayout from "./layouts/PublicLayout";
import AppLayout from "./layouts/AppLayout";
//import Header from './components/Header';
//import Footer from './components/Footer';

import Home from "./pages/Home";
import BookDetails from "./pages/BookDetails";
import Cart from "./components/Cart";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import BlogPage from "./pages/BlogPage";
import EnglishPage from "./pages/EnglishPage";
import HindiPage from "./pages/HindiPage";
import VideoPage from "./pages/VideoPage";
import SpecialBooksPage from "./pages/SpecialBooksPage";


//import POSRoutes from "./pos/routes/PosRoutes"; // POS APP Main file

import POSLayout from "./pos/layout/POSLayout";
import RoleRoute from "./pos/routes/RoleRoute";
import CartPage from "./pos/components/sellModule/CartItem";
import BooksContent from "./pos/components/BooksContent";
import CheckOut from "./pos/components/CheckOut";
import Sell from "./pos/pages/Sell";
import Orders from "./pos/pages/Orders";
import PaymentReceipt from "./pos/components/PaymentReceipt";
import Profile from "./pos/pages/Profile";
import SalesPersons from "./pos/pages/SalesPersons";
import Barcode from "./pos/pages/Barcode";
//import QRSettings from "./pos/pages/QRSettings";
import { Navigate } from "react-router-dom";

import DashboardPage from "./pages/DashboardPage";
import CheckoutPage from "./pages/CheckoutPage";
import TrackPage from "./pages/TrackPage";
import FlipBook from "./common/flipBook";
import TransictionSlip from "./components/core/TransictionSlip";
import TermsConditions from "./components/core/RazorPayPolicy/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
//import { HashLink } from 'react-router-hash-link';
//import { NavHashLink } from 'react-router-hash-link';
import ScrollToTop from "./customHooks/ScrollToTop";
// import {Privacy}  from './components/core/RazorPayPolicy/Privacy';
import Return from "./components/core/RazorPayPolicy/Return";
import Delivery from "./components/core/RazorPayPolicy/Delivery";
import SerachBookList from "./components/SerachBookList";
//import Sell from './components/Sell/Sell'
import PrivateRoute from "./common/PrivateRoute";
import PartialPaymentRecipt from "./components/core/PartialPaymentRecipt";

// import { Helmet } from 'react-helmet';

// const TRACKING_ID = "G-P943V2FDCP";
// ReactGA.initialize(TRACKING_ID);

function App() {
  const auth = JSON.parse(localStorage.getItem("auth") || "{}");
const isLoggedIn = !!auth.token;
// Example check

  const [loginStatus, setLoginStatus] = useState(false);
  // const location = useLocation();

  // useEffect(() => {
  //   ReactGA.pageview(location.pathname + location.search);
  // }, [location]);

 

  return (
    //   <div>
    // {window.location.pathname !== "/book-sell" && <Header loginStatus={loginStatus} />}
    //     <ScrollToTop>
    //     <Routes>
    //       <Route path="/" element={<Home />} />
    //       <Route path="/cart" element={<Cart />} />
    //       <Route path="/about" element={<AboutPage />} />
    //       <Route path="/contact" element={<ContactPage />} />
    //       <Route path='/track-order' element={<TrackPage />} />
    //       <Route path="/book/:id" element={<BookDetails />} />
    //       <Route path='/login' element={<LoginPage setLoginStatus={setLoginStatus} />} />
    //       <Route element={<PrivateRoute isAuthenticated={isLoggedIn} />}>
    //         <Route path="/profile-dashboard" element={<DashboardPage />} />
    //       </Route>
    //       <Route path='/blog' element={<BlogPage />} />
    //       <Route path='/books/english' element={<EnglishPage />} />
    //       <Route path='/books/hindi' element={<HindiPage />} />
    //       <Route path='/books/special-books-product-gift' element={<SpecialBooksPage />} />
    //       <Route path='/books/video' element={<VideoPage />} />
    //       <Route path='/book/search' element={<SerachBookList />} />
    //       {/* <Route path='/book-sell' element = {<Sell/>}/> */}

    //       <Route path='/books/checkout' element={<CheckoutPage />} />
    //       <Route path='/books/flip' element={<FlipBook />} />
    //       <Route path='/transactionslip' element={<TransictionSlip />} />
    //       <Route path='/payment-success' element={<PartialPaymentRecipt/>} />

    //       <Route path='/terms-conditions-rl-fw' element={<TermsConditions />} />
    //       <Route path='/privacy-policies-rl-fw' element={<PrivacyPolicy />} />
    //       {/* <Route path='/privacy-rl-fw' element={<Privacy/>}/> */}
    //       <Route path='/terms-delivery-rl-fw' element = {<Delivery/>}/>
    //       <Route path='/terms-return-rl-fw' element = {<Return/>}/>

    //       <Route path='*' element={<Home />} />
    //     </Routes>
    //     </ScrollToTop>

    //     <Footer />
    //   </div>

    <div>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        newestOnTop
        closeOnClick
        draggable
        pauseOnHover
        closeButton
      />

      <ScrollToTop>
        <Routes>
          {/* 🌐 WEBSITE ROUTES */}
          <Route element={<PublicLayout loginStatus={loginStatus} />}>
            <Route path="/" element={<Home />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/track-order" element={<TrackPage />} />
            <Route path="/book/:id" element={<BookDetails />} />
            <Route
              path="/login"
              element={<LoginPage setLoginStatus={setLoginStatus} />}
            />
            <Route element={<PrivateRoute isAuthenticated={isLoggedIn} />}>
          <Route path="/profile-dashboard" element={<DashboardPage />} />
        </Route>
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/books/english" element={<EnglishPage />} />
            <Route path="/books/hindi" element={<HindiPage />} />
            <Route
              path="/books/special-books-product-gift"
              element={<SpecialBooksPage />}
            />
            <Route path="/books/video" element={<VideoPage />} />
            <Route path="/book/search" element={<SerachBookList />} />
            <Route path="/books/checkout" element={<CheckoutPage />} />
            <Route path="/books/flip" element={<FlipBook />} />
            <Route path="/transactionslip" element={<TransictionSlip />} />
            <Route path="/payment-success" element={<PartialPaymentRecipt />} />
            <Route
              path="/terms-conditions-rl-fw"
              element={<TermsConditions />}
            />
            <Route path="/privacy-policies-rl-fw" element={<PrivacyPolicy />} />
            <Route path="/terms-delivery-rl-fw" element={<Delivery />} />
            <Route path="/terms-return-rl-fw" element={<Return />} />
          </Route>

          {/* 📱 APP / DASHBOARD ROUTES */}
          <Route element={<AppLayout />}>
          
          <Route
              path="/pos/login"
              element={<LoginPage  setLoginStatus={setLoginStatus} />}
            />

            <Route element={<PrivateRoute />}>
              <Route path="/pos" element={<POSLayout />}>
                <Route index element={<Navigate to={auth?.role === "Admin" ? "/pos/orders" : "/pos/sell"} replace />} />

                {/* Sales only */}
                <Route element={<RoleRoute roles={["Salesperson"]} />}>
                  <Route path="sell" element={<Sell />} />
                  <Route path="book/:id" element={<BooksContent />} />
                  <Route path="checkout" element={<CheckOut/>} />
                  <Route path="cart" element={<CartPage />} />
                  <Route path="payment-slip" element={<PaymentReceipt />} />
                </Route>

                {/* Admin + Sales */}
                <Route element={<RoleRoute roles={["Admin", "Salesperson"]} />}>
                  <Route path="orders" element={<Orders />} />
                  <Route path="profile" element={<Profile />} />
                </Route>

                {/* Admin only */}
                <Route element={<RoleRoute roles={["Admin"]} />}>
                  <Route path="users" element={<SalesPersons />} />
                  <Route path="barcode" element={<Barcode />} />
                  {/* <Route path="qr" element={<QRSettings />} /> */}
                </Route>
                
              </Route>
            </Route>
          </Route>

          {/* <Route element={<AppLayout />}>
            <Route element={<PrivateRoute isAuthenticated={isLoggedIn} />}>
              <Route path="/pos/*" element={<POSRoutes />} />
            </Route>
          </Route> */}

          <Route path="*" element={<Home />} />
        </Routes>
      </ScrollToTop>
    </div>
  );
}

export default App;
